import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Custom User type to replace oidc-client-ts dependency
export interface User {
  access_token: string;
  token_type: string;
  expires_at: number;  // Unix timestamp in seconds
  expired: boolean;
  profile: {
    sub: string;  // Client/Punter ID
    name?: string;
    email?: string;
    [key: string]: any;  // Allow additional claims
  };
  refresh_token?: string;
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  isLoading: true,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User | null>) {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
      state.isLoading = false;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
    },
    // Reset auth state to initial (for modal close/reopen)
    resetAuth(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.isLoading = true;
    },
  },
});

export const { setUser, setLoading, logout, resetAuth } = authSlice.actions;
export default authSlice.reducer;
